import { render, staticRenderFns } from "./b-innerlabel.global.vue?vue&type=template&id=7bcd0a8a"
var script = {}
import style0 from "./b-innerlabel.global.vue?vue&type=style&index=0&id=7bcd0a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
